import classNames from "classnames";
import LinkIcon from "assets/icons/LinkIcon";
import styles from "./styles.module.scss";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import FindSimilarIcon from "assets/icons/FindSimilarIcon";
import { Tooltip } from "antd";

interface ActionButtonsProps {
  linkClicked: boolean;
  showSimilarityButton: boolean;
  onLinkClick: () => void;
  onSimilarityClick: (negation?: boolean) => void;
}

const ActionButtons = ({
  linkClicked,
  onLinkClick,
  onSimilarityClick,
  showSimilarityButton,
}: ActionButtonsProps) => {
  return (
    <div className={styles.actionButtons}>
      <Tooltip title={linkClicked ? "Copied!" : "Copy URL"}>
        <div
          className={classNames(
            styles.actionButton,
            styles.copyUrlButton,
            styles.noDetailsClick,
          )}
          onClick={onLinkClick}
        >
          <LinkIcon clicked={linkClicked} />
        </div>
      </Tooltip>
      {showSimilarityButton && (
        <>
          <Tooltip title="Find Similar">
            <div
              onClick={() => onSimilarityClick(false)}
              className={classNames(styles.actionButton, styles.noDetailsClick)}
            >
              <FindSimilarIcon />
              <TooltipWrapper id="assetpreview-find-similar-button-tooltip" />
            </div>
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default ActionButtons;
